import { Action } from "redux"

import * as actions from "./actions"
import { transformIndicatorData } from "../../util/Indicator"

export const initialState: Indicators.Indicators = {
    indicatorId: 0,
    indicatorSchemeId: 0,
    indicators: [],
    isLoading: false,
    indicatorDetail: {
        indicator: {
            chartData: {
                datasets: [],
            },
            color: "",
            description: "",
            hasChart: false,
            id: 0,
            showLabels: true,
            title: "",
            url: "",
            value: 0,
        },
    },
}

const ACTION_HANDLERS: {
    [action: string]: (
        state: Indicators.Indicators,
        props: Action,
    ) => Indicators.Indicators
} = {
    [actions.REQUEST_INDICATORS]: (
        state,
        { indicatorId, indicatorSchemeId }: actions.RequestIndicators,
    ): Indicators.Indicators => ({
        ...state,
        isLoading: true,
        indicatorId,
        indicatorSchemeId,
    }),

    [actions.RECEIVE_INDICATORS]: (
        state,
        { indicators }: actions.ReceiveIndicators,
    ): Indicators.Indicators => ({
        ...state,
        indicators: indicators.map((indicator) =>
            transformIndicatorData(indicator, false),
        ),
        isLoading: false,
    }),

    [actions.REQUEST_INDICATOR]: (
        state,
        { indicatorId }: actions.RequestIndicator,
    ): Indicators.Indicators => ({
        ...state,
        isLoading: true,
        indicatorId,
    }),

    [actions.RECEIVE_INDICATOR]: (
        state,
        { indicator }: actions.ReceiveIndicator,
    ): Indicators.Indicators => ({
        ...state,
        indicatorDetail: {
            ...state.indicatorDetail,
            indicator: transformIndicatorData(indicator, true),
        },
        isLoading: false,
    }),

    [actions.RECEIVE_INDICATOR_ERROR]: (state): Indicators.Indicators => ({
        ...state,
        isLoading: false,
    }),
}

export default function reducer(
    state = initialState,
    action: Action,
): Indicators.Indicators {
    const handler: (
        state: Indicators.Indicators,
        action: Action,
    ) => Indicators.Indicators = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
